// Constants and Utils
import { getDifferenceInDays } from "../../common-utils/date-utils/DateUtils";
import { DurationConstants } from "../../constants/GeneralConstants";

// get Reach For Duration
export function getReachForDuration(reach, cityPlanDuration) {
  // if no reach present
  if (!reach) {
    return 0;
  }

  // for duration
  const reachForDuration =
    (cityPlanDuration * reach) / DurationConstants.THIRTY_DAYS;

  return reachForDuration;
}

// get Total Reach Of Selected Medias Stretches
export function getTotalReachOfSelectedMediasStretches(
  cityPlan = {},
  citySpecificMediaList = [],
  roadStretchDetailsMap = {}
) {
  // if no media added to campaign for city
  if (citySpecificMediaList.length === 0) {
    return 0;
  }

  // city plan
  const { startTimestamp, endTimestamp } = cityPlan || {};

  // city plan duration
  const cityPlanDuration =
    getDifferenceInDays(startTimestamp, endTimestamp) - 1;

  // new Set give unique stretchIds (remove duplicates)
  const selectedMediasStretchIds = [
    ...new Set(citySpecificMediaList.map((media) => media.roadStretchId)),
  ];

  // get stretches reach
  const stretchesReachMap = {};
  selectedMediasStretchIds.forEach((stretchId) => {
    const stretchInfo = roadStretchDetailsMap[stretchId];
    const { reachAvg } = stretchInfo || {};

    // reach for duration
    const durationReach = getReachForDuration(reachAvg, cityPlanDuration);

    // update reach for stretch
    stretchesReachMap[stretchId] = durationReach;
  });

  // get sum of reach for all stretches
  const totalReach = Object.values(stretchesReachMap).reduce(
    (sum, reach) => sum + reach,
    0
  );

  // final return
  return totalReach;
}
